import { GetPreviousEditableFieldValuesDocument } from 'src/lib/gql-client'
import { graphqlRequest } from 'src/lib/gql-client/request'

import { Worksheet, FieldValue } from '../../types'
import { parseGqlWorksheetFieldValue } from '../parser'

export type PreviousEditableFieldValues = {
  worksheetUid: Worksheet['uid']
  worksheetLogUid: string
  fieldValues: FieldValue[]
}

export const getPreviousEditableFieldValues = async ({
  worksheetUid,
}: {
  worksheetUid: Worksheet['uid']
}): Promise<PreviousEditableFieldValues> => {
  try {
    const res = await graphqlRequest(GetPreviousEditableFieldValuesDocument, {
      worksheetUid,
    })

    return {
      worksheetUid: res.worksheet.worksheetUid as Worksheet['uid'],
      worksheetLogUid: res.worksheet.latestWorksheetLog.worksheetLogUid,
      fieldValues: res.worksheet.latestWorksheetLog.fieldValues.map(fv =>
        parseGqlWorksheetFieldValue(fv),
      ),
    }
  } catch (e) {
    throw e
  }
}
